import { Livewire, Alpine } from '../../../../../../../../vendor/livewire/livewire/dist/livewire.esm';
import Clipboard from '@ryangjchandler/alpine-clipboard'

Alpine.plugin(Clipboard)
Livewire.start()

// core version + navigation, pagination modules:
import {Swiper, Navigation, Pagination, Grid, Autoplay, EffectCards, EffectCoverflow, EffectFlip, Thumbs} from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-cards';
import 'swiper/css/effect-coverflow';
import 'swiper/css/effect-flip';
import 'swiper/css/grid';
import 'swiper/css/autoplay';
window.Swiper = Swiper

// Swal
import Swal from 'sweetalert2';
window.Swal = Swal;
window.Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: 3330,
    timerProgressBar: true
});

// Lazyload
import lazySizes from 'lazysizes';

// fslightbox
import FsLightbox from "fslightbox";

// Fancybox
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import PureCounter from "@srexi/purecounterjs";

const setupApp = ()=>
{
    lazySizes.init();
    refreshFsLightbox();

    // Fancybox
    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    });

    const pure = new PureCounter({
        formater: "fa-Fa",
    });

    let lastScrollTop = 0;
    const topbar = document.getElementById("topbar");
    const navbar = document.getElementById("main-navbar");

    window.addEventListener("scroll", function () {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > lastScrollTop) {
            topbar.classList.add("topbar-hidden");
            navbar.classList.add("fixed-top");
        } else {
            topbar.classList.remove("topbar-hidden");
            navbar.classList.remove("fixed-top");
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    });


    let heroSwiper = new Swiper("#heroSwiper", {
        modules: [Navigation],
        slidesPerView: 2,
        loop: true,
        spaceBetween: 5,
        breakpoints: {
            480: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 4,
            },
            1280: {
                spaceBetween: 14,
                slidesPerView: 3.5,
            },
        },
        navigation: {
            nextEl: "#heroSwiperNext",
            prevEl: "#heroSwiperPrev",
        },
    });


    let specialCategoriesSwiper = new Swiper("#specialCategoriesSwiper", {
        modules: [Navigation],
        slidesPerView: 1.5,
        loop: true,
        spaceBetween: 10,
        breakpoints: {
            480: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 4,
            },
            1280: {
                spaceBetween: 14,
                slidesPerView: 5,
            },
        },
        navigation: {
            nextEl: "#specialCategoriesSwiperNext",
            prevEl: "#specialCategoriesSwiperPrev",
        },
    });


    let colorSeparationSwiper = new Swiper("#colorSeparationSwiper", {
        modules: [Grid],
        slidesPerView: 2.5,
        grid: {
            rows: 2,
            fill: 'row'
        },
        spaceBetween: 30,
        breakpoints: {
            480: {
                slidesPerView:2,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 3.5,
            },
            1280: {
                slidesPerView: 5,
            },
        },
    });



    let specialCategoriesSwiper2 = new Swiper("#specialCategoriesSwiper2", {
        modules: [Navigation],
        slidesPerView: 1.5,
        loop: true,
        spaceBetween: 10,
        breakpoints: {
            480: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 4,
            },
            1280: {
                spaceBetween: 14,
                slidesPerView: 5,
            },
        },
        navigation: {
            nextEl: "#specialCategoriesSwiperNext2",
            prevEl: "#specialCategoriesSwiperPrev2",
        },
    });


    let blogSwiper2 = new Swiper("#blogSwiper", {
        modules: [Navigation],
        slidesPerView: 1.5,
        loop: true,
        spaceBetween: 10,
        breakpoints: {
            480: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 4,
            },
            1280: {
                spaceBetween: 14,
                slidesPerView: 5,
            },
        },
        navigation: {
            nextEl: "#blogSwiperNext",
            prevEl: "#blogSwiperPrev",
        },
    });

    let aboutHeroSwiper = new Swiper("#aboutHeroSwiper", {
        modules: [Navigation, Autoplay, EffectFlip],
        slidesPerView: 1,
        loop: true,
        effect: "flip",
        spaceBetween: 5,
        breakpoints: {
            480: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 1,
            },
            1024: {
                cardsEffect: {
                    perSlideOffset: 3,
                    perSlideRotate: 4,
                    rotate: true,
                    slideShadows:false,
                },
                slidesPerView: 1,
            },
            1280: {
                cardsEffect: {
                    perSlideOffset: 3,
                    perSlideRotate: 4,
                    rotate: true,
                    slideShadows:false,
                },
                spaceBetween: 5,
                slidesPerView: 1,
            },
        },
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: "#aboutHeroSwiperNext",
            prevEl: "#aboutHeroSwiperPrev",
        },
    });

    let aboutCertificatesSwiper = new Swiper("#aboutCertificatesSwiper", {
        modules: [Navigation],
        slidesPerView: 1.5,
        spaceBetween: 16,
        loop: true,
        centeredSlides: true,
        breakpoints: {
            480: {
                slidesPerView:2,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                centeredSlides: false,
                slidesPerView: 3.5,
            },
            1280: {
                centeredSlides: false,
                slidesPerView: 5,
            },
        },
        navigation: {
            nextEl: "#aboutCertificatesSwiperrNext",
            prevEl: "#aboutCertificatesSwiperrPrev",
        },
    });

    const wrappers = document.querySelectorAll('.tilt-wrapper');

    wrappers.forEach(wrapper => {
        const inner = wrapper.querySelector('.tilt-inner');

        wrapper.addEventListener('mousemove', (e) => {
            const rect = wrapper.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;

            const centerX = rect.width / 2;
            const centerY = rect.height / 2;

            const rotateX = ((y - centerY) / centerY) * 10;
            const rotateY = ((x - centerX) / centerX) * 10;

            inner.style.transform = `rotateX(${-rotateX}deg) rotateY(${rotateY}deg)`;
        });

        wrapper.addEventListener('mouseleave', () => {
            inner.style.transform = 'rotateX(0deg) rotateY(0deg)';
        });
    });

    let productGalleryThumb = new Swiper('.product-thumb-imgs-swiper-container', {
        modules: [Navigation],
        direction: 'horizontal',
        spaceBetween: 10,
        slidesPerView: 3,
        breakpoints: {
            768:{
                slidesPerView: 4,
            },
        },
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    });

    let productGallery = new Swiper('.product-imgs-swiper-container', {
        modules: [Navigation, Thumbs],
        direction: 'horizontal',
        centeredSlides:true,
        centeredSlidesBounds:true,
        slidesPerView:1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        spaceBetween: 10,
        thumbs: {
            swiper : productGalleryThumb
        },
    });

    let productRelatedItems = new Swiper('.product-related-items',  {
        slidesPerView: 1.2,
        spaceBetween: 15,
        breakpoints:{
            768:{
                slidesPerView: 2.3,
            },
            1024: {
                slidesPerView:3.3,
            },
            1280:{
                slidesPerView:4.3,
            },
        }
    });

};
["livewire:initialized", "livewire:navigated", "resize", "pageChanged"].forEach((event) => {
    window.addEventListener(event, setupApp)
})

